export default {
  kbSearchListEmptyState: '0 articles found',
  articlesEmptyAltText: 'Articles empty',
  kbSearchListMaxArticles: '{{number}}+ results',
  kbFeaturedArticles: 'Featured Articles',
  kbCategories: 'Categories',
};
